class ColorSwatches extends HTMLElement {
    connectedCallback() {
      this.selectors = {
        colorSwatchImage: '.grid-product__color-image',
        colorSwatch: '.color-swatch--with-image',
        gridItemLink: '.product-grid-item',
        gridProductImageWrap: '.grid-product__image-wrap',
        // 悬浮 Add to Cart 按钮的选择器
        quickAddActions: '.grid-product__actions',
        quickAddBtn: '.quick-add-btn'
      }
  
      this.gridItemLink = this.closest(this.selectors.gridItemLink)
      
      // 如果没找到 .product-grid-item，尝试找更外层的 .grid-item
      if (!this.gridItemLink) {
        this.gridItemLink = this.closest('.grid-item')
      }
      
      this.gridProductImageWrap = this.gridItemLink ? this.gridItemLink.querySelector(this.selectors.gridProductImageWrap) : null
      this.colorImages = this.gridProductImageWrap ? this.gridProductImageWrap.querySelectorAll(this.selectors.colorSwatchImage) : []
      
      // 获取悬浮按钮容器和按钮
      if (this.gridProductImageWrap) {
        this.quickAddActions = this.gridProductImageWrap.querySelector(this.selectors.quickAddActions)
        this.quickAddBtn = this.gridProductImageWrap.querySelector(this.selectors.quickAddBtn)
      }
      
      // 保存原始按钮信息
      if (this.quickAddBtn) {
        this.originalButtonText = this.quickAddBtn.querySelector('.icon__fallback-text')?.textContent.trim() || 'Add to cart'
        this.originalButtonTitle = this.quickAddBtn.getAttribute('title') || 'Add to cart'
        this.soldOutText = 'Sold out'
      }
  
      // 始终绑定事件，无论商品变量是否有图片
      this.swatches = this.querySelectorAll(this.selectors.colorSwatch)
      if (!this.swatches.length) {
        this.swatches = this.querySelectorAll('.color-swatch')
      }
      if (this.swatches.length) {
        this.colorSwatchHovering()
      }
    }
  
    colorSwatchHovering() {
      this.swatches.forEach((swatch) => {
        // 手机端 touch
        swatch.addEventListener('touchstart', (evt) => {
          evt.preventDefault()
          evt.stopPropagation()
          this.setActiveColorImage(swatch)
        }, { passive: false })
  
        // 点击 swatch （桌面 / 手机 都生效）
        swatch.addEventListener('click', (evt) => {
          evt.preventDefault()
          evt.stopPropagation()
          this.setActiveColorImage(swatch)
        })
      })
    }
  
    setActiveColorImage(swatch) {
      const id = swatch.dataset.variantId
      const image = swatch.dataset.variantImage
      const isAvailable = swatch.dataset.variantAvailable === 'true'
  
      this.colorImages.forEach((el) => {
        el.classList.remove('is-active')
      })
      this.swatches.forEach((el) => {
        el.classList.remove('is-active')
      })
  
      const imageEl = this.gridProductImageWrap
        ? this.gridProductImageWrap.querySelector('.grid-product__color-image--' + id)
        : null
      if (imageEl) {
        imageEl.style.backgroundImage = 'url(' + image + ')'
        imageEl.classList.add('is-active')
      }
      swatch.classList.add('is-active')
      
      // 更新悬浮 Add to Cart 按钮状态
      this.updateQuickAddButton(isAvailable, id)
    }
    
    updateQuickAddButton(isAvailable, variantId) {
      if (!this.quickAddActions) return
      
      // 重新获取按钮（因为可能被动态替换）
      this.quickAddBtn = this.quickAddActions.querySelector(this.selectors.quickAddBtn)
      if (!this.quickAddBtn) return
      
      const textEl = this.quickAddBtn.querySelector('.icon__fallback-text')
      
      // 获取外层包装器 (tool-tip-trigger, quick-add 等)
      const toolTipTrigger = this.quickAddBtn.closest('tool-tip-trigger')
      const quickAddWrapper = this.quickAddBtn.closest('quick-add')
      
      if (isAvailable) {
        // 有库存 - 恢复原始状态
        if (textEl) {
          textEl.textContent = this.originalButtonText
        }
        this.quickAddBtn.setAttribute('title', this.originalButtonTitle)
        this.quickAddBtn.disabled = false
        this.quickAddBtn.removeAttribute('data-sold-out')
        this.quickAddBtn.classList.remove('quick-add-btn--sold-out')
        
        // 移除外层包装器的禁用状态
        if (toolTipTrigger) {
          toolTipTrigger.classList.remove('is-sold-out')
          toolTipTrigger.style.pointerEvents = ''
        }
        if (quickAddWrapper) {
          quickAddWrapper.classList.remove('is-sold-out')
          quickAddWrapper.style.pointerEvents = ''
        }
        
        // 更新 variant ID (如果是单变体快速添加)
        if (this.quickAddBtn.hasAttribute('data-single-variant-quick-add')) {
          this.quickAddBtn.setAttribute('data-id', variantId)
        }
      } else {
        // 无库存 - 显示 Sold out 并禁用
        if (textEl) {
          textEl.textContent = this.soldOutText
        }
        this.quickAddBtn.setAttribute('title', this.soldOutText)
        this.quickAddBtn.disabled = true
        this.quickAddBtn.setAttribute('data-sold-out', 'true')
        this.quickAddBtn.classList.add('quick-add-btn--sold-out')
        
        // 禁用外层包装器
        if (toolTipTrigger) {
          toolTipTrigger.classList.add('is-sold-out')
          toolTipTrigger.style.pointerEvents = 'none'
        }
        if (quickAddWrapper) {
          quickAddWrapper.classList.add('is-sold-out')
          quickAddWrapper.style.pointerEvents = 'none'
        }
      }
    }
  
    removeActiveColorImage(swatch) {
      const id = swatch.dataset.variantId
      const imageEl = this.gridProductImageWrap.querySelector(`.grid-product__color-image--${id}`)
      if (imageEl) {
        imageEl.classList.remove('is-active')
      }
      swatch.classList.remove('is-active')
    }
  }
  
  if (!customElements.get('color-swatches')) {
    customElements.define('color-swatches', ColorSwatches)
  }
  